import React, { useState } from "react";
import "./A23SingleSelect.css";

const A23SingleSelect = (props) => {
  const [selected, setSelected] = useState(null);

  let listData = { data: [] };

  try {
    listData = JSON.parse(props?.data?.text || "{}");
  } catch (e) {
    console.error("Invalid JSON:", e);
  }

  const handleSelect = (item) => {
    if (item?.disabled) return;

    setSelected(item?.value);

    props?.handleClick?.(props?.code, item?.value);
    props?.setTextOnClick?.(item?.name);
  };

  return (
    <div className="a23-single-select action-tab">
      {listData?.data?.map((item, index) => (
        <div
          key={index}
          className={`a23-card ${
            selected === item?.value ? "selected" : ""
          }`}
          onClick={() => handleSelect(item)}
        >
          <div className="a23-card-top">
            <div className="a23-radio">
              {selected === item?.value && (
                <div className="a23-radio-inner" />
              )}
            </div>

            <div className="a23-content">
              <div className="a23-title">{item?.name}</div>

              {item?.desc && (
                <div className="a23-subtitle">
                  {item?.desc}
                </div>
              )}
            </div>

            {item.url && (
              <img
                src={item.url}
                alt={item.name}
                className="a23ss-img"
              />
            )}

            {item?.badge && (
              <div className="a23-badge">
                {item?.badge}
              </div>
            )}
          </div>

          {item?.subDescription && (
            <div className="a23-sub-description">
              <span className="a23-sub-description-icon">ⓘ</span>
              {item.subDescription}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default A23SingleSelect;